import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      mirrors: {
        mirrors_list_js: {
          add_tracking: {
            header: 'JS_ADD_HEADER',
            tabs: {
              manual: {
                tab_name: 'JS_TAB_NAME_MANUAL',
              },
              from_file: {
                tab_name: 'JS_FROM_FILE_TAB_NAME',
              },
            },
          },
        },
        mirrors_list_no_js: {
          add_tracking: {
            header: 'NO_JS_ADD_HEADER',
            save: 'NO_JS_SAVE',
            back: 'NO_JS_BACK',
            tabs: {
              manual: {
                tab_name: 'NO_JS_TAB_NAME_MANUAL',
              },
              from_file: {
                tab_name: 'NO_JS_FROM_FILE_TAB_NAME',
              },
            },
          },
        },
      },
    },
  }));
}
